import {inject, Injectable} from "@angular/core";
import {AppearanceHelperZoom} from "src/app/core/services/services/appearance-service.d/appearance-helper-zoom";
import {Browser} from "src/app/core/services/services/appearance-service.d/appearance-helper-browser";
import {AppearanceService} from "src/app/core/services/services/appearance.service";
import {CustomizingService} from "src/app/core/services/services/customizing.service";
import {firstValueFrom} from "rxjs";
import {AuthenticationService} from "src/app/core/services/services/authentication.service";

@Injectable({
	providedIn: "root",
})
export class AnalyticsService {
	public mepVersion: string;
	public mepEnvironment: string;
	public mepUserRoles: string;
	public mepUserUsername: string;
	public mepUserId: number;

	private readonly appearanceService = inject(AppearanceService);
	private readonly customizingService = inject(CustomizingService);
	private readonly authenticationService = inject(AuthenticationService);

	constructor() {
		this.getData();
	}

	private getData() {
		this.customizingService.getWarFileName().then((version: string) => (this.mepVersion = version));
		this.customizingService.getEnvironment().then((env: string) => (this.mepEnvironment = env));
		firstValueFrom(this.authenticationService.getUserRoles()).then(
			(result) => (this.mepUserRoles = result.join(", ").toLowerCase()),
		);
		this.authenticationService.getApplicationUser().then((user) => {
			this.mepUserUsername = user.username;
			this.mepUserId = user.employee?.id;
		});
	}

	public getSystemInformation() {
		let displayHeight = screen.height;
		let displayWidth = screen.width;
		let windowOuterHeight = window.outerHeight;
		let windowOuterWidth = window.outerWidth;

		if (this.appearanceService.appearanceHelperBrowser.likelyBrowser() === Browser.FIREFOX) {
			displayWidth = Math.round(window.devicePixelRatio * displayWidth);
			displayHeight = Math.round(window.devicePixelRatio * displayHeight);
			windowOuterWidth = Math.round(window.devicePixelRatio * windowOuterWidth);
			windowOuterHeight = Math.round(window.devicePixelRatio * windowOuterHeight);
		}

		let text = `*--- Software*
OS: ${this.appearanceService.appearanceHelperBrowser.getOS()}
Browser: ${this.appearanceService.appearanceHelperBrowser.likelyBrowser()}
*--- MEP*
Environment: ${this.mepEnvironment}
Version: ${this.mepVersion === "" ? "N/A" : this.mepVersion}
User: ${this.mepUserUsername}
UserId: ${this.mepUserId}
Roles: ${this.mepUserRoles}
Page URL: ${window.location.href}
*--- Size*
Display: ${displayWidth} x ${displayHeight}
Window: ${windowOuterWidth} x ${windowOuterHeight}
Page: ${window.innerWidth} x ${window.innerHeight}
*--- Zoom*
Device zoom: ${window.devicePixelRatio * 100}%
MEP zoom: ${AppearanceHelperZoom.zoom() * 100}%
*--- Appearance*
Darkreader status: ${this.appearanceService.config.darkMode()}
System Dark mode: ${globalThis.matchMedia("(prefers-color-scheme: dark)").matches}
Default Color Scheme: ${this.appearanceService.defaultColorSchemeSelected()}
`;

		if (!this.appearanceService.defaultColorSchemeSelected()) {
			text += `Color Scheme: ${JSON.stringify(this.appearanceService.colorScheme())}
`;
		}

		text += `*---*
User Agent: ${navigator.userAgent}
`;

		return text;
	}
}
